import axios from "axios";
import { useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RateSettings({ month, onSaved }) {
  const [value, setValue] = useState("");
  const [message, setMessage] = useState("");

  const save = async () => {
    if (!value) return;
    await axios.post(`${API}/rates/manual`, { rate: Number(value), kind: "manual_monthly", month });
    setMessage("Aylık kur kaydedildi");
    setValue("");
    onSaved?.();
  };

  return (
    <section className="rate-settings panel">
      <div>
        <p className="eyebrow">KUR YÖNETİMİ</p>
        <h3>Manuel aylık kur</h3>
        <p>TCMB kuru alınamadığında raporların devam etmesi için yedek değer tanımlayın.</p>
      </div>
      <div className="rate-form">
        <input data-testid="manual-rate-input" type="number" step="0.0001" placeholder="USD / TL kuru" value={value} onChange={e => setValue(e.target.value)}/>
        <button data-testid="save-manual-rate-button" className="outline-btn" onClick={save}>Kuru kaydet</button>
      </div>
      {message && <small data-testid="rate-saved-notice">{message}</small>}
    </section>
  );
}
